import $ from "jquery";
import { HtmlFix, HtmlScroll } from "./common.js";

function Modal() {
  var closeButton = $(".js-modal-close");

  //モーダル表示
  $(document).on("click", ".js-modal-trigger", function () {
    var target = $(this).attr("data-target"),
      targetModal = document.querySelector(target);
    $(target).fadeIn(300);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    HtmlFix();
  });

  // ESCキーを押したときの処理を無効化し、modalClose()を発火
  $(document).on("keydown", ".js-modal", function (e) {
    //プレビュー中は閉じない
    if ($(this).hasClass("is-initial-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      return;
    } else if ($(this).hasClass("is-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      modalClose();
    }
  });

  //閉じるボタンクリックで閉じる
  closeButton.on("click", function () {
    modalClose();
  });

  //オーバーレイクリックで閉じる
  $(".js-modal").on("click", function (e) {
    var target = $(e.target);
    if (!target.closest(".js-modal-content").length) {
      modalClose();
    }
  });

  //モーダル閉じる処理
  function modalClose() {
    var openModal = document.querySelector(".js-modal.is-open");

    if (openModal) {
      $(".js-modal").fadeOut(300);
      setTimeout(function () {
        openModal.close();
      }, 300);
      openModal.classList.remove("is-open");
      HtmlScroll();
    }
  }

  //PC時のみ表示のモーダル、リサイズ時の処理
  $(window).on("resize", function () {
    var windowWidth = $(window).width();
    if (windowWidth < 768 && $(".js-modal").hasClass("only-pc")) {
      modalClose();
    }
  });
}

export { Modal };
